import { render, staticRenderFns } from "./LegalMinimumWageValidation.vue?vue&type=template&id=139f4815&scoped=true"
import script from "./LegalMinimumWageValidation.vue?vue&type=script&lang=js"
export * from "./LegalMinimumWageValidation.vue?vue&type=script&lang=js"
import style0 from "./LegalMinimumWageValidation.vue?vue&type=style&index=0&id=139f4815&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139f4815",
  null
  
)

export default component.exports